export default function ExclusiveReveal() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="relative bg-foreground-950 rounded-2xl overflow-hidden">
          <div className="absolute top-8 left-8 text-accent-300/15 text-9xl font-serif select-none leading-none">
            &ldquo;
          </div>

          <div className="relative z-10 flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative">
              <div className="relative h-[350px] md:h-[450px] lg:h-full w-full lg:-ml-8 lg:-mt-8 lg:-mb-8 overflow-hidden rounded-xl lg:rounded-r-none">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20person%20in%20dramatic%20lighting%2C%20fashion%20editorial%20style%2C%20strong%20chiaroscuro%20effect%20with%20warm%20golden%20light%20on%20face%2C%20dark%20background%2C%20elegant%20and%20mysterious%20mood%2C%20clean%20minimalist%20composition%2C%20soft%20shadows%2C%20high%20end%20magazine%20photography%20quality&width=700&height=900&seq=testimonial-2026&orientation=portrait"
                  alt="用户评价"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:w-3/5 flex flex-col justify-center px-6 md:px-12 py-10 md:py-16">
              <p className="text-lg md:text-xl text-background-50 leading-relaxed mb-8 font-heading">
                51黑料网是我每天的快乐源泉，信息更新速度快、内容真实可靠，推荐给所有爱吃瓜的朋友！吃瓜氛围一级棒，评论区比内容还精彩！
              </p>
              <div className="mb-8">
                <p className="text-base font-semibold text-background-50">吃瓜群众代表</p>
                <p className="text-sm text-foreground-400 mt-1">51黑料网忠实用户</p>
              </div>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-400 text-foreground-950 font-semibold rounded-full text-sm hover:bg-secondary-500 transition-colors w-fit whitespace-nowrap"
              >
                查看更多评价 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}